module.exports = __webpack_public_path__ + "img/selected2-min.dd7717e3.png";